import "./assets/css/admin.css"

import App from "./comps/routes/Router.svelte"
import { mount } from "svelte"

const app = mount(App, {
	target: document.getElementById("app"),
})

export default app
